export const URL_AGREEMENT_OF_PERSONAL_DATA =
    'https://euro-ins.ru/calc/files/soglasie-na-obrabotku-pd.pdf'

export const URL_POLICY_PERSONAL_DATA = 'https://euro-ins.ru/calc/files/personal_data.pdf'
